import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import "react-drawer/lib/react-drawer.css"
import { Link } from "react-router-dom"
// import ProfileMenu from "../Common/ProfileMenu"
import logo from "../../assets/images/logo.svg"
import QueryString from "query-string"

import { withRouter, Redirect } from "react-router-dom"
import ProfileMenu from "components/common/ProfileMenu"
// Redux Store

const Header = props => {
  const [search, setsearch] = useState(false)
  const [megaMenu, setmegaMenu] = useState(false)
  const [socialDrp, setsocialDrp] = useState(false)
  const [searchType, handleSearchType] = useState("content_uuid")
  const [searchText, handleSearchText] = useState("")
  const [filters, handleFieldChange] = useState({
    searchType: "content_uuid",
    searchText: null,
  })
  const [clear, setClear] = useState(false)
  const [isSearchTypeChange, handleSearchTypeChange] = useState(false)
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)

  const [position, setPosition] = useState()
  const [open, setOpen] = useState(false)
  const toggleTopDrawer = () => {
    setPosition("right")
    setOpen(!open)
  }

  const onDrawerClose = () => {
    setOpen(false)
  }

  const handleClear = () => {
    setClear(true)
    handleSearchText("")
    handleFieldChange({ ...filters, searchText: "" })
  }

  const searchTextParams = !_.isEmpty(props.queryParams)
    ? props.queryParams.contentUUID ||
      props.queryParams.userUuid ||
      props.queryParams.challengeUuid ||
      props.queryParams.audioId
    : ""

  const searchTypeParams =
    !isSearchTypeChange && !_.isEmpty(props.queryParams)
      ? (props.queryParams.contentUUID && "content_uuid") ||
        (props.queryParams.userUuid && "user_uuid") ||
        (props.queryParams.challengeUuid && "challenge_id") ||
        (props.queryParams.audioId && "audio_id")
      : filters?.searchType || ""

  useEffect(() => {
    let page = props?.history?.location?.pathname.split("/")[1]
    if (page === "user" || page === "appuser") {
      handleFieldChange({ ...filters, searchType: "user_uuid" })
    } else if (page === "content") {
      handleFieldChange({ ...filters, searchType: "content_uuid" })
    } else if (page === "challenge") {
      handleFieldChange({ ...filters, searchType: "challenge_id" })
    } else if (page === "audio") {
      handleFieldChange({ ...filters, searchType: "audio_id" })
    }
  }, [handleFieldChange])

  function toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen()
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen()
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        )
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen()
      }
    }
  }

  function tToggle() {
    var body = document.body
    if (window.screen.width <= 998) {
      body.classList.toggle("sidebar-enable")
    } else {
      body.classList.toggle("vertical-collpsed")
      body.classList.toggle("sidebar-enable")
    }
  }

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex w-100">
            <div className="navbar-brand-box d-lg-none d-md-block">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={logo} alt="" height="22" />
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <img src={logo} alt="" height="22" />
                </span>
              </Link>
            </div>
            <div className="d-flex" style={{ width: "80%" }}>
              <button
                type="button"
                className="btn btn-sm px-3 font-size-16 header-item "
                id="vertical-menu-btn"
              >
                <span className="logo-sm">
                  <img src={logo} alt="" height="22" />
                </span>
              </button>
            </div>

            <div className="d-flex justify-content-end flex-fill">
              <button
                type="button"
                onClick={() => {
                  toggleFullscreen()
                }}
                className="btn header-item noti-icon "
                data-toggle="fullscreen"
              >
                <i className="bx bx-fullscreen" />
              </button>
              <ProfileMenu />
            </div>
          </div>
        </div>
      </header>
    </React.Fragment>
  )
}

const mapStatetoProps = (state, ownProps) => {
  const layoutType = "vertical"
  const showRightSidebar = true
  const leftMenu = true
  const leftSideBarType = "default"

  return {
    layoutType,
    showRightSidebar,
    leftMenu,
    leftSideBarType,
    queryParams: _.get(ownProps, "location.search")
      ? QueryString.parseUrl(_.get(ownProps, "location.search")).query
      : undefined,
  }
}

export default withRouter(Header)
